import { CourseItem, LessonItem } from '@atlassian/learning-components';

import { SUBNAVBAR_HEIGHT } from 'src/pages/LessonPage/utils/utils';

export const scrollToElement = (
  element: HTMLElement,
  intervalId: ReturnType<typeof setInterval>,
  observer: MutationObserver,
): void => {
  window.scrollTo({
    top: element.offsetTop - SUBNAVBAR_HEIGHT,
    behavior: 'smooth',
  });

  clearInterval(intervalId);
  observer.disconnect();
};

export const scrollToSection = (sectionSlug: string): void => {
  const intervalId: ReturnType<typeof setInterval> = setInterval(() => {
    const element = document.getElementById(sectionSlug);

    if (element) {
      scrollToElement(element, intervalId, observer);
    }
  }, 0);

  const observer = new MutationObserver((mutations, obs) => {
    const element = document.getElementById(sectionSlug);

    if (element) {
      scrollToElement(element, intervalId, obs);
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });
};

export const addQuizToLesson = (lesson: LessonItem): LessonItem => ({
  ...lesson,
  sectionListCollection: {
    items: [
      ...(lesson.sectionListCollection?.items || []).map((section) => ({
        ...section,
      })),
      {
        id: 'quiz',
        title: 'Quiz',
        sys: {
          id: 'quiz',
        },
      },
    ],
  },
});

export const addQuizToLessons = (course: CourseItem): CourseItem => ({
  ...course,
  lessonsCollection: {
    items: course.lessonsCollection?.items?.map(addQuizToLesson),
  },
});
